import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import moment from "moment";
import DatePicker from "react-datepicker";
import {Form} from "semantic-ui-react";
import {Field} from "redux-form";

export class DatePickerField extends PureComponent {
  static propTypes = {
    input: PropTypes.any.isRequired,
    meta: PropTypes.any.isRequired,
  };

  render() {
    const minDate = moment().subtract(80, 'years');

    const maxDate = moment().subtract(1, 'day');

    const normalize = value =>
      value ? moment(value).format('YYYY-MM-DD') : null;

    return (
      <Field
        {...this.props}
        normalize={normalize}
        as={Form.Input}
        component={props => {
          const {
            input,
            meta: { touched, error, warning },
          } = props;
          return (
            <div className={cx('field', { error: touched && error })}>
              <div className="ui input datepicker">
                <DatePicker
                  {...props}
                  minDate={minDate}
                  maxDate={maxDate}
                  {...input}
                  dateForm="MM/DD/YYYY"
                  selected={input.value ? moment(input.value) : null}
                />
                {touched &&
                  ((error && (
                    <span className="tiny-message error">
                      <i>{error}</i>
                    </span>
                  )) ||
                    (warning && (
                      <span className="tiny-message warning">
                        <i>{warning}</i>
                      </span>
                    )))}
              </div>
            </div>
          );
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DatePickerField.js